import axios from "axios";

export default {
    data() {
        return {
                //Timer
      TimerObject: {}
        }
    },

    methods: {
        stageTabClick(ndx) {
            try {
                this.activeStageId = this.stages[ndx].stageId;
                this.activeStageNdx = ndx;
                let obj = this.visitSteps.filter((f) => f.stageId == this.activeStageId);
                this.singleStage = JSON.parse(JSON.stringify(obj));
            } catch {/**/ }
            //console.log("****", obj);
        },

     //Timer
 StartLogoutTime() {
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, 1.8e+6);
  },
 ResetLogoutTime(){
    clearTimeout(this.TimerObject);
        this.TimerObject = setTimeout(() => {
         this.AutoLogout();
        }, 1.8e+6);
  },

        datePickerPR() {
            const self = this;
            $('input[name="daterangePR"]').daterangepicker(
                {
                    opens: "left",
                },
                function (start, end) {
                    self.startDatePR = new Date(start);
                    self.endDatePR = new Date(end);
                    self.initDatePR =
                        self.dateToMDY(self.startDatePR) +
                        " - " +
                        self.dateToMDY(self.endDatePR);
                }
            );
        },

        loadInit() {
            const dd = new Date();
            dd.setDate(dd.getDate() - 30);

            this.startDatePR = dd;
            this.endDatePR = new Date();
            this.initDatePR =
                this.dateToMDY(this.startDatePR) +
                " - " +
                this.dateToMDY(this.endDatePR);

            this.StartLogoutTime();
            this.fetchInitData();
        },

        fetchInitData() {
            this.intDummyComm();
            if (this.selectedUsers.length > 0) {
                let aa = [];
                for (let i = 0; i < this.selectedUsers.length; i++)
                    aa.push(this.users[this.selectedUsers[i]].id);
                this.dummyComm.extras = aa.toString();
                //alert(this.selectedUsers.toString() + "    "+this.dummyComm.extras)
            } else this.dummyComm.extras = "";

            if (this.selectedPractice + "".length > 0) {
                this.dummyComm.extras1 = this.selectedPractice;
            } else this.dummyComm.extras1 = "";

            if (this.initDatePR.length > 0) {
                this.dummyComm.myDate = this.dateToSqlServerDateFormat(
                    this.startDatePR
                );
                this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
            } else {
                this.dummyComm.myDate = null;
                this.dummyComm.myTime = null;
            }

            //this.payments=[];
            //this.dummyComm.extras = "";
            const url = this.SERVER + "/VNSPRAAPI/Reports/StaffReportInitData";

            this.axiosGetData(url, 1);

            this.$nextTick(() => {
                $("#table001").DataTable().destroy();
                $("#table001").DataTable({
                    pageLength: 50,
                    lengthMenu: [
                      [50, 100, 500, 1000, 2000, -1],
                      [50, 100, 500, 1000, 2000],
                    ],
                    buttons: ["copy", "csv", "excel", "pdf", "print"],
                });
                $(
                    ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
                ).addClass("btn btn-primary mr-1");
                $(".table001").DataTable().draw();
            }); // this.$nextTick
        },

        //------------------------------------------ Common Methods
        async axiosGetData(myUrl, what) {
            var loader = this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            await axios({
                method: "post",
                url: myUrl,
                data: this.dummyComm,
                 headers:{
                    Authorization: this.$store.getters.getAuthToken,
                  }
            })
                .then((res) => {
                    loader.hide();
                    // if everything goes well -- we will get data
                    this.lastErrorCode = 1;
                    if (what === 1) {
                        console.log(res.data);
                        this.users = res.data.users;
                        this.practices = res.data.practices;
                        this.stages = res.data.stages;
                        this.visitSteps = res.data.visitSteps;
                        //this.payments = res.data.payments;

                        this.activeStageId = this.stages[0].stageId;
                        this.stageTabClick(0);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        this.lastErrorCode = 1;
                        alert("-> " + error.response.data);
                        alert("-> " + error.response.status);
                        alert("-> " + error.response.headers);
                    } else if (error.request) {
                        this.lastErrorCode = 1;
                        alert("No response " + error.request);
                    } else {
                        this.lastErrorCode = 1;
                        alert("Error", error.message);
                    }
                })
                .finally(() => {
                    this.ResetLogoutTime();
                    loader.hide(); });
        }, // axiosGetData

    }, // end methods
    mounted(){
        if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    },
    unmounted() {
        clearTimeout(this.TimerObject);
      },
}
